import { decorate, extendObservable, computed } from "mobx";
import Core from "Core";
import UserRoles from "../Enums/UserRoles";
import CharacterReplacer from "../../../Core/CharacterReplacer";
import moment from "moment";
import PasswordExpirationTime from "../Enums/PasswordExpirationTime";

export class User extends Core.Stores.Model {
  constructor(store, id) {
    super(store, id);

    extendObservable(this, {
      CustomerId: null,
      Name: null,
      Email: null,
      Password: null,
      PasswordUpdated: null,
      RoleId: 0, // Standard user
    });
  }

  get asJSON() {
    return {
      Id: this.Id,
      CustomerId: this.CustomerId,
      Name: this.Name,
      Email: this.Email,
      Password: CharacterReplacer.replaceForbiddenCharacters(this.Password),
      PasswordUpdated: this.PasswordUpdated,
      RoleId: this.RoleId,
      LastUpdated: this.LastUpdated instanceof moment ? this.LastUpdated.format() : null,
    };
  }

  get isPrimaryUser() {
    return this.RoleId === new UserRoles().CONTRACTMANAGER.Key || this.RoleId === new UserRoles().ADMINISTRATOR.Key;
  }

  get isAdmin() {
    return this.RoleId === new UserRoles().ADMINISTRATOR.Key;
  }

  parseAsDate(key) {
    return key === "LastUpdated";
  }

  generatePassword() {
    const randomPassword = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);

    return randomPassword;
  }

  isPasswordExpired(passwordExpirationId) {
    let expired = false;

    const passwordExpirationTime = new PasswordExpirationTime();
    const timeAddition = passwordExpirationTime.findByKey(passwordExpirationId);

    if (moment(this.PasswordUpdated).add(timeAddition.Name) < moment()) expired = true;
    return expired;
  }
}

decorate(User, {
  asJSON: computed,
  isAdmin: computed,
  isPrimaryUser: computed,
});



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Models/User.js